import React, { useState, useEffect } from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import './App.css';
import Details from './Views/Details'
import Follow from './Views/Follow';
import { createTheme, ThemeProvider} from '@material-ui/core/styles';
import Navbar from "./Components/Navbar";
import { acceptationEnvironment } from './constants'

const favicon: HTMLLinkElement | null = document.querySelector('[rel=icon]')

if (acceptationEnvironment && favicon) {
    document.title = 'TracefyAcc | Vehicle Tracking'
    favicon.href = '/accicons/favicon-32x32.png'
}

const App = () => {
    const [nightmode, setNightmode] = useState(false)

    useEffect(() => {
        if (window.localStorage.getItem('TracefyTrackingNightmode') === 'true') {
            setNightmode(true)
        }
    }, [])

    const theme = createTheme({
        palette: {
            type: nightmode ? 'dark' : 'light',
            primary: {
                main: nightmode ? '#272727' : '#173c60',
                contrastText: '#fff',
            },
            secondary: {
                light: '#C97200',
                main: '#C97200',
                dark: '#C97200',
                contrastText: '#000',
            },
        },
        overrides: {
            MuiTooltip: {
                tooltip: {
                    fontSize: "0.8em",
                },
            },
        }
    });

    return (
        <ThemeProvider theme={theme}>
                <Router>
                    <Navbar nightmode={nightmode} setNightmode={setNightmode}/>
                    <Switch>
                        <Route path="/follow/:token">
                            <Follow />
                        </Route>
                        <Route path="/:id">
                            <Details />
                        </Route>
                    </Switch>
                </Router>
        </ThemeProvider>
    )
};

export default App;
